<div class="container">
	<div class="row">
		<div class="col-lg-6">
			<div class="panel">
				<div class="heading">User info</div>
				<div class="content">
					<div class="mb-3">
						<label for="smsnumber">SMS Number</label>
						<input [(ngModel)]="smsnumber" name="smsnumber" type="text" class="form-control">
					</div>
					<div class="mb-3">
						<app-action-button [action]="UpdateSMS" [context]="this" processing="Updating..." complete="SMS Updated">
							Update</app-action-button>
					</div>
				</div>
			</div>
			<div class="panel">
				<div class="heading">Change Password</div>
				<div class="content">
					<form>
						<div class="mb-3">
							<label for="password">Old Password</label>
							<input [(ngModel)]="oldpassword" name="oldpassword" type="password" class="form-control" autocomplete="current-password">
						</div>
						<div class="mb-3">
							<label for="password">New Password</label>
							<input [(ngModel)]="newpassword" name="newpassword" type="password" class="form-control" autocomplete="new-password">
						</div>
						<div class="mb-3">
							<label for="password">New Password (confirm)</label>
							<input [(ngModel)]="matchpassword" name="matchpassword" type="password" class="form-control" autocomplete="new-password">
						</div>
						<div class="mb-3">
							<app-action-button submit [action]="ChangePassword" [context]="this" processing="Updating..." complete="Password Changed">
								Change Password</app-action-button>
						</div>
					</form>
				</div>
			</div>
			@if (userOptions) {
				<div class="panel">
					<div class="heading">Multi Factor Authentication</div>
					<div class="content">
						<div class="row text-center mt-3">
							<div class="col-sm-6">
								<div class="mb-3">
									MFA is:
									@if (userOptions.mfa_enabled) {
										<span class="message-good">Enabled</span>
									}
									@if (!userOptions.mfa_enabled) {
										<span class="message-bad">Disabled</span>
									}
								</div>
							</div>
							<div class="col-sm-6">
								<div class="mb-3">
									@if (!userOptions.mfa_enabled) {
										<a class="button" [routerLink]="['../enable-mfa']">Enable MFA</a>
									}
									@if (userOptions.mfa_enabled) {
										<a class="button" [routerLink]="['../disable-mfa']">Disable MFA</a>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			}
		</div>
		<div class="col-lg-6">
			@if (userOptions) {
				<div class="panel">
					<div class="heading">Mute Notification types</div>
					<div class="content">
						@if (!brand.fixedassets) {
							<div class="row">
								<div class="col-8 mb-3">
									Import notifications
								</div>
								<div class="col-4 form-check">
									<label>
										<input [(ngModel)]="userOptions.mute_imports" type="checkbox">
										Mute
									</label>
								</div>
							</div>
						}
						<div class="row">
							<div class="col-8 mb-3">
								Device failure notifications
							</div>
							<div class="col-4 form-check">
								<label>
									<input [(ngModel)]="userOptions.mute_commfails" type="checkbox">
									Mute
								</label>
							</div>
						</div>
						<div class="mb-3">
							<app-action-button [action]="UpdateNotifications" [context]="this" processing="Updating..." complete="Notification settings updated">
								Update</app-action-button>
						</div>
					</div>
				</div>
			}
			@if (notifyorgs && notifyorgs.length > 0) {
				<div class="panel">
					<div class="heading">Asset Notification Subscriptions</div>
					<div class="content">
						@for (org of notifyorgs; track org) {
							<div>
								@for (fleet of org.fleets; track fleet) {
									<div>
										<h5>{{org.organization_name}} - {{fleet.fleet_name}}</h5>
										@for (asset of fleet.assets; track asset) {
											<div class="row">
												<div class="col-8 mb-3">
													{{ asset.asset_name }}@if (asset.asset_serial_number) {
														<span> ({{asset.asset_serial_number}})</span>
													}
												</div>
												<div class="col-2 form-check">
													<label class="nowrap">
														<input [(ngModel)]="asset.enable_email" type="checkbox">
														Email
													</label>
												</div>
												<div class="col-2 form-check">
													<label class="nowrap">
														<input [(ngModel)]="asset.enable_sms" type="checkbox">
														SMS
													</label>
												</div>
											</div>
										}
									</div>
								}
							</div>
						}
						<div class="mb-3">
							<app-action-button [action]="UpdateAssets" [context]="this" processing="Updating..." complete="Notifications Updated">Update</app-action-button>
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</div>